(function () {
  var drawer = document.querySelector('.oddit-search-drawer');
  if (!drawer) return;

  var results = drawer.querySelector('[data-search-results]');
  var defaultResults = results ? results.innerHTML : '';

  var searchUrl = drawer.getAttribute('data-search-url') || '/search';
  var resourceTypes = drawer.getAttribute('data-search-resource-types') || 'product,article';
  var resultsLimit = drawer.getAttribute('data-search-results-limit') || '4';

  var MIN_QUERY = 2;
  var DEBOUNCE_MS = 250;
  var debounceTimer = null;
  var inflight = null;

  // The drawer is pinned below the sticky header, so it needs the header's
  // current bottom edge both to sit flush under it and to size its own panel.
  var header = document.querySelector('.oddit-header');

  function measureOffset() {
    var top = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    drawer.style.setProperty('--oddit-search-drawer-top', top + 'px');
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    measureOffset();
    // Full-height on mobile only works if the page behind can't scroll away.
    document.body.style.overflow = 'hidden';
    // The drawer's own input is display:none on desktop, where the header input
    // is the real field — don't steal focus from it.
    var input = drawer.querySelector('[data-search-input]');
    if (input && input.offsetParent !== null) input.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.addEventListener('resize', function () {
    if (drawer.classList.contains('is-open')) measureOffset();
  });

  function trimResults(container, limit) {
    ['[data-search-products] .oddit-search-drawer__product', '[data-search-articles] .oddit-search-drawer__blog'].forEach(function (selector) {
      var items = container.querySelectorAll(selector);
      for (var i = items.length - 1; i >= limit; i--) {
        items[i].parentNode.removeChild(items[i]);
      }
    });
  }

  function showDefault() {
    if (!results) return;
    results.innerHTML = defaultResults;
    results.classList.remove('oddit-search-drawer__columns--results');
    drawer.classList.remove('is-loading');
  }

  function search(query) {
    if (!results) return;
    if (inflight) inflight.abort();
    inflight = new AbortController();
    drawer.classList.add('is-loading');

    var url =
      searchUrl +
      '?q=' + encodeURIComponent(query) +
      '&type=' + encodeURIComponent(resourceTypes) +
      '&options[prefix]=last' +
      '&section_id=oddit-search-results';

    fetch(url, { signal: inflight.signal })
      .then(function (res) {
        if (!res.ok) throw new Error('Search failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parsed = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-search-results-inner]');
        if (!parsed) return;
        results.innerHTML = parsed.innerHTML;
        trimResults(results, parseInt(resultsLimit, 10) || 4);
        results.classList.add('oddit-search-drawer__columns--results');
        drawer.classList.remove('is-loading');
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        drawer.classList.remove('is-loading');
        showDefault();
      });
  }

  // Both fields drive the drawer: the header input on desktop, the drawer's own
  // input on mobile.
  document.querySelectorAll('[data-search-input]').forEach(function (input) {
    input.addEventListener('input', function () {
      var query = this.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < MIN_QUERY) {
        if (inflight) inflight.abort();
        showDefault();
        return;
      }

      debounceTimer = setTimeout(function () {
        search(query);
      }, DEBOUNCE_MS);
    });
  });

  function reset() {
    clearTimeout(debounceTimer);
    if (inflight) inflight.abort();
    document.querySelectorAll('[data-search-input]').forEach(function (input) {
      input.value = '';
    });
    showDefault();
  }

  var overlay = drawer.querySelector('[data-search-overlay]');
  if (overlay) overlay.addEventListener('click', close);

  drawer.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      reset();
      close();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('click', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (drawer.contains(e.target)) return;
    if (e.target.closest('[data-search-toggle], .oddit-header__search-input')) return;
    close();
  });

  window.OdditSearchDrawer = {
    open: open,
    close: close,
    toggle: function () {
      if (drawer.classList.contains('is-open')) close(); else open();
    }
  };
})();
